import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../colors';

const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    justifyContent: 'left',
    padding: theme.spacing(2),
    backgroundColor: Colors.white,
    borderRadius: '8px',
    '&&': {
        fontFamily: 'Jost'
    },
}));

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '1rem',
    color: Colors.mediumGray,
    fontFamily: 'Jost',
    textTransform: 'uppercase',
}));

const MainText = styled(Typography)(({ theme }) => ({
    fontSize: '1.2rem',
    fontWeight: 'bold',
    fontFamily: 'Jost',
}));

const MainTextEmptyMsg = styled(Typography)(({ theme }) => ({
    fontSize: '1.2rem',
    fontWeight: 400,
    fontFamily: 'Jost',
    fontStyle: 'italic',
    textTransform: 'capitalize',
}));

const SubText = styled(Typography)(({ theme }) => ({
    fontSize: '0.95rem',
    color: `${Colors.gray}`,
    fontWeight: 'bold',
    fontFamily: 'Jost',
}));

const InfoRow = ({ iconComponent, title, mainText = '', subText, isEditable, onClickHandler }) => {
    return (
        <Row onClick={isEditable ? onClickHandler : undefined} >
            <Box
                sx={{ color: 'black', marginRight: '5px' }} >
                {iconComponent}
            </Box>
            <Box>
                <Title>{title}</Title>
                {mainText.length === 0 ?
                    <MainTextEmptyMsg>Not specified</MainTextEmptyMsg>
                    :
                    <MainText>{mainText}</MainText>
                }
                <SubText>{subText}</SubText>
            </Box>
            {isEditable && <EditIcon sx={{ marginLeft: 'auto' }} />}
        </Row>
    );
};

export default InfoRow;